import { Injectable } from '@angular/core';
import { Models } from './@models/_models';
import { ActivatedRoute, Router } from '@angular/router';


@Injectable({
    providedIn: 'root'
})
export class DataService {

    public current_table = '';

    constructor(private route: ActivatedRoute, private router: Router) {
        this.current_table = router.url.replace('/', '');
    }

    public hasProfileLink(row, field, table, type) {
        let _with = type.split(':')[3];
        return (row.profile_fields && row.profile_fields.indexOf(field) != -1 && row[_with]) || (table == 'user' && field == 'user_id');
    }

    public isRelation(type) {
        if (type.indexOf('relation:') == 0 || type.indexOf('readonly:') == 0) {
            return true;
        }
    }

    public applyWith(table, qb) {
        table = table.toLowerCase();
        if (Models[table]) {
            qb.with((new Models[table]).relations);
        }
    }

    public applyModels(table, data) {
        table = table.toLowerCase();
        if (Models[table]) {
            for (let i in data) {
                data[i] = Object.assign(data[i], new Models[table]);
            }
        }
        return data;
    }
}
